import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from 'components';
import { eclipseDriveSidebarImage, eclipseDriveRefLinksImage } from 'assets/images';
import styles from './styles.module.scss';

const stepNumbers = ['01', '02', '03', '04', '05'] as const;

export const CashbackSection = () => {
  const { t } = useTranslation('eclipseDrive');

  return (
    <div className={styles.section}>
      <div className={styles.section_bg_container}>
        <Image
          url={eclipseDriveSidebarImage}
          alt=""
          className={styles.section_bg_left}
        />
        <Image
          url={eclipseDriveRefLinksImage}
          alt=""
          className={styles.section_bg_right}
        />
      </div>
      <div className={styles.section_content}>
        <div className={styles.header}>
          <h2 className={styles.section_title}>
            {t('cashback.title')}
          </h2>
          <p className={styles.section_subtitle}>
            {t('cashback.subtitle')}
          </p>
        </div>
        
        <div className={styles.cashback_container}>
          <div className={styles.accounts_preview}>
            <div className={styles.account_card}>
              <h3 className={styles.account_title}>{t('cashback.mainAccount')}</h3>
              <p className={styles.account_balance}>{t('cashback.mainBalance')}</p>
              <span className={styles.account_button}>{t('cashback.withdraw')}</span>
            </div>
            
            <div className={styles.account_card}>
              <h3 className={styles.account_title}>{t('cashback.temporaryAccount')}</h3>
              <p className={styles.account_days}>{t('cashback.daysProgress')}</p>
              <div className={styles.progress_bar}>
                <div
                  className={styles.progress_fill}
                  style={{ width: '75%' }}
                />
              </div>
              <div className={styles.account_stats}>
                <div className={styles.stat_row}>
                  <span>{t('cashback.superCases')}</span>
                  <span>{t('cashback.amount')}</span>
                </div>
                <div className={styles.stat_row_value}>
                  <span>3/5 :</span>
                  <span>$ 432</span>
                </div>
              </div>
              <span className={`${styles.account_button} ${styles.account_button_blocked}`}>{t('cashback.blocked')}</span>
            </div>
          </div>
          
          <div className={styles.steps_container}>
            {stepNumbers.map((num, index) => (
              <div
                key={num}
                className={styles.step_item}
              >
                <span className={styles.step_number}>{num}</span>
                <span className={styles.step_text}>{t(`cashback.steps.step${index + 1}`)}</span>
              </div>
            ))}
          </div>
        </div>
        
        <p className={styles.disclaimer}>
          {t('cashback.disclaimer')}
        </p>
      </div>
    </div>
  );
};
